export const packingOfCargoOptionsKeys = ["pallets", "boxes", "without_packing", "barrels", "boxes1"] as const;

export const stackabilityOfCargoOptionKeys = ["yes", "no"] as const;

export const fragileCargoOptionKeys = ["yes", "no"] as const;

export const availabilityOfBatteriesOptionKeys = ["yes", "no"] as const;
